export const filterNavByAccess = (nodes = [], ability) => {
  if (!Array.isArray(nodes)) return [];
  if (!ability) return [];

  // ✅ Admin/wildcard shows full nav
  if (ability.can?.('*')) return nodes;

  const allow = (n) => {
    if (n.feature && !ability.hasFeature?.(n.feature)) return false;
    if (
      Array.isArray(n.featuresAny) &&
      n.featuresAny.length &&
      !ability.hasAnyFeature?.(n.featuresAny)
    )
      return false;
    if (
      Array.isArray(n.featuresAll) &&
      n.featuresAll.length &&
      !ability.hasAllFeatures?.(n.featuresAll)
    )
      return false;
    if (n.perm && !ability.can?.(n.perm)) return false;
    if (
      Array.isArray(n.permsAny) &&
      n.permsAny.length &&
      !ability.canAny?.(n.permsAny)
    )
      return false;
    return true;
  };

  const walk = (list) =>
    list
      .map((n) => {
        if (!allow(n)) return null;
        if (Array.isArray(n.children) && n.children.length) {
          const children = walk(n.children);
          if (
            (n.type === 'group' || n.type === 'collapse') &&
            children.length === 0
          )
            return null;
          return {...n, children};
        }
        return n;
      })
      .filter(Boolean);

  return walk(nodes);
};
